<template>
  <div class="MyTicketsAgent">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>My Tickets</span>
            </h1>
            <div class="page-header-subtitle" v-if="status!='all'">Support Tickets - {{status}}</div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <List :tickets="tickets" routeName="TicketDetailsAgent"></List>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import List from "@/components/List.vue";

export default {
  name: "TicketsAgent",

  data() {
    return {
      tickets: [],
      status: "",
    };
  },

  watch: {
    "$route.params.status": function (status) {
      this.loadTickets(status);
      this.status = status;
      window.scrollTo(0, 0);
    },
  },

  mounted() {
    let status = "all";
    if (this.$route.params.status != undefined) {
      status = this.$route.params.status;
    }
    this.loadTickets(status);
    this.status = status;
  },

  methods: {
    loadTickets(status) {
      let loading = this.$loading.show();
      axios.get("/user/tickets?status=" + status).then((res) => {
        if (res.data.status == "success") {
          this.tickets = res.data.tickets;
        } else {
          //this.$swal("Ooops!", res.data.message, "error");
          this.tickets = [];
        }
        loading.hide();
      });
    },
  },

  components: {
    List,
  },

  computed: {
    authUser() {
      return this.$store.state.authUser;
    },
  },
};
</script>


